/**
 * @file   src\components\Footer.tsx
 * @brief  Footer component.
 * @date   JUN, 2024
 * @author ZCO Engineer
 * @copyright (c) 2024, ZCO
 */
import { React, useState,  Link, useParams , PWAPrompt, Button, Col, useNavigate, useEffect, useRef} from '../utils/thirdpartyComponents';
import '../components/CWFooter.scss';
import { pageURLs } from 'src/utils/pageUrls';
import InstallApplication from "src/components/InstallApplication";
import Closeicon from "../assets/images/close-icon-small.svg";
import LocationPermission from './LocationPermission';
import Appimg from "../assets/images/CW-appicon.svg";
import IosShareIocn from "../assets/images/ios-share-icon.svg";
import IOSAddIocn from "../assets/images/ios-add-icon.svg";
import { MessageToaster } from 'src/utils/toastUtil';
import { getBayTypes, getFromLocalStorage, subscriptionRedirection } from 'src/utils/helper';
import axios from '../config/axiosConfig';
import { BayApi } from 'src/utils/apiUrls';
import { BayItem, IBayType } from 'src/interfaces/bayinterface';
import { ServiceType } from 'src/utils/enums';

const CWFooter = (props:any) => {
  const params = useParams();
  const navigate = useNavigate();
  
  const showIOSPWAPromptStatus = props.showIOSPWAPrompt? true : false
  const showAndroidPWAPromptStatus = props.showAndroidPWAPrompt ? 1 : 0;
  const [activeLink, setActiveLink] = useState<string>(props.activeLink); // Default active link
  const [geolocation, setLocation] = useState({ lat: 0, long: 0 });
  const [error, setError] = useState("");
  const [buttonRedirectURL,setButtonRedirectURL] = useState("");
  const [hasActiveWash, setHasActiveWash] = useState(false);
  const hasRedirectedToSelfService = useRef(false);


  const showLocationPermissionPrompt = (props.showLocationPermissionPrompt) ? props.showLocationPermissionPrompt : false;

  // Instantiate MessageToaster
  const toaster = new MessageToaster();

  // Triggers on clicking not implimented items
  function handleComingsoon() {
    toaster.toastSuccess("Coming soon!");
  }


  const handleLinkClick = (url: string) => {
    setActiveLink(url);
  };

   // Callback function when location is granted
   const handleLocationGranted = (coords: { lat: number; long: number }) => {
   // console.log(coords)
    setLocation(coords);
  };

  // Callback function when there is an error
  const handleError = (errorMessage: string) => {
    setError(errorMessage);
  };

  const onIosPromptClose = () => {
    props.closedIosAction()
    localStorage.setItem('closedIosPrompt',"true")
  }

// function to find the active self wash
  const getUserActiveWashdetails = async () => {
    try {
    const { data } = await axios.get(BayApi.GET_ACTIVE_WASH)
    const isOnSelfServicePage = location.pathname.includes(pageURLs.selfService);
    if (
      data?.error === 0 &&
      data?.data?.userSubscriptionID > 0 &&
      data?.data?.bayID > 0
    ) {
      setHasActiveWash(true)
      if (!isOnSelfServicePage && !hasRedirectedToSelfService.current) {
        hasRedirectedToSelfService.current = true;
        let searchparam = `activewash=1&bayTypeId=${data?.data?.bayTypeId}`
        if(data?.data?.hasVacuumWash == 1)
        {
          searchparam = `activewash=1&bayTypeId=${data?.data?.bayTypeId}&freeVacuum=true`
        }
        else if(data?.data?.hasSelfService == 1)
        {
          searchparam = `activewash=1&bayTypeId=${data?.data?.bayTypeId}&freeSelfServe=true`
        }
        navigate(`/${params.carwashname}/${pageURLs.selfService}?${searchparam}`,{ state: { UserSubscriptionID: data?.data?.userSubscriptionID ,bayId:data?.data?.bayID ,redirectedFromFooter: true}});
      }
    }
  
  } catch (error: any) {
    console.log(error.response?.data?.message)
  }
  }

  // const btnRedirection= async () => {
  //    const redirectURL = await subscriptionRedirection(params.carwashname ?? "")
  // }

  const settings = getFromLocalStorage('CARWASH_COMPANY_SETTINGS_DATA') || {};
  const IsCustom = settings?.IsCustom ? settings.IsCustom : 0;
  //if default design set defalut logo
  const Logourl_from_appsettings = IsCustom === 0 ? "" : getFromLocalStorage('LOGO_URL_SETTINGS_DATA');

  const fetchRedirectURL = async () => {
    const redirectURL = await subscriptionRedirection(params.carwashname ?? "");
    setButtonRedirectURL(redirectURL ?? "");
  };

    useEffect(() => {
    getUserActiveWashdetails()
    fetchRedirectURL();
   
  }, []);


  const handleHomeClick = async (e: React.MouseEvent) => {
    e.preventDefault();
  
    try {
      const { data } = await axios.get(BayApi.GET_ACTIVE_WASH);
      const activeWash =
        data?.error === 0 &&
        data?.data?.userSubscriptionID > 0 &&
        data?.data?.bayID > 0;
  
      if (activeWash) {
        toaster.toastError("You cannot leave during an active wash.");
      } else {
        navigate("/" + params.carwashname + "/" + pageURLs.home)
        handleLinkClick("Home");
      }
    } catch (error) {
      console.error("Failed to check active wash", error);
      handleLinkClick("Home");
      
    }
  }
  return (
    <div className="footer-wrap">{}
      <ul className="footer-inner-wrap">
      {/* {localStorage.getItem('closedIosPrompt') == 'true' && <li><Button  variant="primary" className='primary-btn btn-main m-0'  onClick={()=>{setShouldShowPWAPrompt(true)}} >Allow</Button></li>} */}
        <li>
          <Link to={"/" + params.carwashname + "/" + pageURLs.home}
            title="Home"
            className={activeLink === 'Home' ? 'active' : ''}
            onClick={handleHomeClick}
            // onClick={() => handleLinkClick('Home')}
          >
            <div className="btm-nav-icon">
              <svg xmlns="http://www.w3.org/2000/svg" width="24.808" height="20.565" viewBox="0 0 24.808 20.565"><g transform="translate(0.037 0.064)"><g transform="translate(0 0)"><path d="M13.4,7.794a1.364,1.364,0,1,1-1.365,1.364A1.364,1.364,0,0,1,13.4,7.794" transform="translate(-1.031 -0.668)" fill="#fff" /><path d="M13.763,7.044a2.478,2.478,0,1,1-2.48,2.479A2.481,2.481,0,0,1,13.763,7.044Zm0,3.456a.978.978,0,1,0-.98-.978A.979.979,0,0,0,13.763,10.5Z" transform="translate(-1.395 -1.032)" fill="#515151" /><path d="M21.026,20.565H15.971a.75.75,0,0,1-.747-.683l-.309-3.463h-4.63l-.259,3.453a.75.75,0,0,1-.748.694H4.4a.75.75,0,0,1-.75-.75V6.891a.75.75,0,0,1,.306-.6L12.3.146a.75.75,0,0,1,.891,0l8.278,6.141a.75.75,0,0,1,.3.6V19.815A.75.75,0,0,1,21.026,20.565Zm-4.369-1.5h3.619V7.268l-7.53-5.586L5.148,7.27V19.065H8.583l.259-3.453a.75.75,0,0,1,.748-.694H15.6a.75.75,0,0,1,.747.683Z" transform="translate(-0.377 -0.064)" fill="#515151" /><path d="M.438,4.49-.438,3.272,4.96-.609,5.836.609Z" transform="translate(0.401 5.549)" fill="#515151" /><path d="M4.96,4.49-.438.609.438-.609l5.4,3.881Z" transform="translate(18.935 5.549)" fill="#515151" /></g></g></svg>
            </div>
            Home
          </Link>
        </li>

        <li>
          {/* <Link to={"/" + params.carwashname + "/" + pageURLs.subscriptionandwashprice} title="Subscriptions"
            className={activeLink === 'Subscriptions' ? 'active' : ''}
            onClick={() => handleLinkClick('Subscriptions')}> */}
            <Link to={buttonRedirectURL} title="Subscriptions"
            className={activeLink === 'Subscriptions' ? 'active' : ''}
            onClick={() => handleLinkClick('Subscriptions')}>
            <div className="btm-nav-icon">
              <svg xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" width="25.974" height="20.088" viewBox="0 0 25.974 20.088"><defs><clipPath id="a"><rect width="25.974" height="20.088" fill="none" stroke="#515151" strokeWidth="1" /></clipPath></defs><g transform="translate(0 0)"><g transform="translate(0 0)" clipPath="url(#a)"><path d="M5.7,19.083H.929A.918.918,0,0,1,0,18.178V2.234a.918.918,0,0,1,.929-.905H5.7v1.25H1.25V17.833H5.7Z" transform="translate(-0.038 -0.118)" fill="#515151" /><path d="M5.158,8.258a2.423,2.423,0,1,1,.721-4.737l-.3.954a1.423,1.423,0,1,0,.013,2.715l.3.952A2.428,2.428,0,0,1,5.158,8.258Z" transform="translate(-0.195 -0.236)" fill="#515151" /><path d="M3.249.5H0v-1H3.249Z" transform="translate(2.424 9.788)" fill="#515151" /><path d="M2.278.5H0v-1H2.278Z" transform="translate(3.396 11.977)" fill="#515151" /><path d="M5.83,17.888H3.676a1.65,1.65,0,0,1,0-3.3h2.15v1H3.676a.65.65,0,0,0,0,1.3H5.83Z" transform="translate(-0.152 -0.91)" fill="#515151" /><path d="M26.387,19.083H21.613v-1.25h4.453V2.579H21.613V1.329h4.774a.918.918,0,0,1,.929.905V18.178A.918.918,0,0,1,26.387,19.083Z" transform="translate(-1.304 -0.118)" fill="#515151" /><path d="M22.323,8.258a2.418,2.418,0,0,1-.741-.115l.306-.952a1.423,1.423,0,1,0,.01-2.715l-.3-.955a2.423,2.423,0,1,1,.722,4.737Z" transform="translate(-1.312 -0.236)" fill="#515151" /><path d="M3.249.5H0v-1H3.249Z" transform="translate(20.3 9.788)" fill="#515151" /><path d="M2.278.5H0v-1H2.278Z" transform="translate(20.3 11.977)" fill="#515151" /><path d="M23.754,17.888H21.6v-1h2.154a.65.65,0,1,0,0-1.3H21.6v-1h2.15a1.65,1.65,0,1,1,0,3.3Z" transform="translate(-1.303 -0.91)" fill="#515151" /><path d="M.234-.625H10.482a.86.86,0,0,1,.859.859V18.679a.86.86,0,0,1-.859.859H.234a.86.86,0,0,1-.859-.859V.234A.86.86,0,0,1,.234-.625ZM10.091.625H.625V18.288h9.466Z" transform="translate(7.57 0.587)" fill="#515151" /><path d="M13.641,2.55a2.735,2.735,0,1,1-2.734,2.735A2.738,2.738,0,0,1,13.641,2.55Zm0,4.469a1.735,1.735,0,1,0-1.734-1.735A1.736,1.736,0,0,0,13.641,7.019Z" transform="translate(-0.688 -0.184)" fill="#515151" /><path d="M5.563.5H0v-1H5.563Z" transform="translate(10.199 10.059)" fill="#515151" /><path d="M3.179.5H0v-1H3.179Z" transform="translate(11.383 12.533)" fill="#515151" /><path d="M15.689,18.295H11.551a1.5,1.5,0,1,1,0-3h4.138a1.5,1.5,0,0,1,0,3Zm-4.138-2a.5.5,0,0,0,0,1h4.138a.5.5,0,0,0,0-1Z" transform="translate(-0.637 -0.953)" fill="#515151" /></g></g></svg>
            </div>
            Subscriptions
          </Link>
        </li>

        <li>
          <Link to={"/" + params.carwashname + "/" + pageURLs.settings} title="Settings"
            className={activeLink === 'Settings' ? 'active' : ''}
            onClick={() => handleLinkClick('Settings')}>
            <div className="btm-nav-icon">
              <svg xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" width="21.5" height="21.49" viewBox="0 0 21.5 21.49"><defs><clipPath id="a"><rect width="21.5" height="21.49" transform="translate(0 0)" fill="#515151" /></clipPath></defs><path d="M8.97,3.69l1.17-2.07.08-.12h1.09l.069.12,1.17,2.08,1.921.8,2.3-.63.14-.04.11.1.56.57.11.1-.04.14-.64,2.3.79,1.92,2.08,1.18.12.071v1.1l-.12.071-2.08,1.17L17,14.47l.63,2.3.039.139L17,17.581l-.11.1-.14-.04L14.46,17l-1.92.8-1.18,2.07-.081.12H10.19l-.071-.12L8.949,17.8,7.03,16.99l-2.3.63-.14.04-.67-.67-.11-.1.04-.14.64-2.3L3.7,12.53,1.63,11.35l-.13-.069v-1.1l.13-.069L3.7,8.941,4.51,7.02l-.63-2.3L3.84,4.58l.77-.769.14.039,2.29.64ZM9.34,0,7.959,2.43,7.92,2.5l-.08.04-.81.33-.08.03-.08-.02-2.7-.75L2.16,4.14,2.9,6.83l.019.09L2.89,7l-.34.81-.03.08-.08.04L0,9.311V12.15l2.43,1.39.08.04.03.08.34.81.03.08-.02.08-.76,2.7,2.01,2.01,2.7-.74.08-.029L7,18.61l.82.34.07.03.05.08,1.369,2.43H12.16l1.379-2.43.041-.07.08-.03.82-.34.07-.03.09.02,2.69.75,2.02-2.01-.75-2.7-.021-.08.031-.08.34-.81.04-.08.07-.04,2.44-1.379V9.34L19.07,7.951l-.08-.041-.03-.08-.33-.81-.04-.08.03-.08.75-2.7L17.36,2.15l-2.7.74-.08.031L14.5,2.88l-.81-.34-.08-.03-.05-.07L12.189,0Z" fill="#515151" /><g clipPath="url(#a)"><path d="M10.75,6.955a3.79,3.79,0,1,0,3.79,3.79,3.79,3.79,0,0,0-3.79-3.79m0,6.08a2.29,2.29,0,1,1,2.29-2.29,2.29,2.29,0,0,1-2.29,2.29" fill="#515151" fillRule="evenodd" /></g></svg>
            </div>
            Settings
          </Link>
        </li>

        <li>
          {/* uncomment and change the link when it is impletented  */}
          <Link to={"/" + params.carwashname + "/" + pageURLs.notifications} title="Notifications"
            className={activeLink === 'Notifications' ? 'active' : ''}
            onClick={() => handleLinkClick('Notifications')}>
              {/* <Link to={""} title="Notifications"
            className={activeLink === 'Notifications' ? 'active' : ''}
            onClick={() => handleComingsoon()}> */}
            <div className="btm-nav-icon">
              <svg xmlns="http://www.w3.org/2000/svg" width="21.341" height="21.346" viewBox="0 0 21.341 21.346">
                <g id="bell" transform="translate(-2.006 -2)">
                  <path id="Path_623" data-name="Path 623" d="M23.18,19.054,20.4,15.639l-.1-6.015a.763.763,0,0,0,0-.122C19.421,4.729,16.646,2,12.675,2,8.482,2,5.112,5.049,4.289,9.486a.762.762,0,0,0,0,.137l-.1,6.1L2.108,19.138A.778.778,0,0,0,2.764,20.3H9.625a3.049,3.049,0,0,0,6.1,0h6.861a.766.766,0,0,0,.595-1.243ZM12.675,21.822A1.525,1.525,0,0,1,11.15,20.3H14.2A1.525,1.525,0,0,1,12.675,21.822ZM4.113,18.772,5.638,16.3a.762.762,0,0,0,.107-.381L5.813,9.7C6.507,6,9.259,3.525,12.675,3.525c4.292,0,5.664,3.812,6.1,6.175l.107,6.221a.762.762,0,0,0,.168.473l1.936,2.379Z" transform="translate(0)" fill="#515151" />
                </g>
              </svg>
            </div>
            Notifications
          </Link>
        </li>
      </ul>
      {(localStorage.getItem('installPromptCancelled') !== 'true' || showAndroidPWAPromptStatus == 1) ? <InstallApplication showAndroidPWAPromptStatus = {showAndroidPWAPromptStatus}/> : ''}
            {/* PWA installation prompt for ios */}
        <PWAPrompt   permanentlyHideOnDismiss={false}  promptOnVisit={1} copyClosePrompt={<img src={Closeicon} width={14} height={14} alt="Close" />}  copyShareStep = {<div dangerouslySetInnerHTML={{__html: 'Press the "Share" <img src="'+IosShareIocn+'" alt="Car Wash App" width="25px" height="25px"> button on menu bar below, then press "Add to home screen" <img src="'+IOSAddIocn+'" alt="Car Wash App" width="18px" height="18px"> button'}} />} copyAddToHomescreenStep = {""} appIconPath={Logourl_from_appsettings ? `${process.env.REACT_APP_S3_URL_PUBLIC_PATH}${Logourl_from_appsettings}` : Appimg } isShown={showIOSPWAPromptStatus} onClose={onIosPromptClose}/>
       {showLocationPermissionPrompt === true ? <LocationPermission
      
      onLocationGranted={handleLocationGranted}
      onError={handleError}
    /> : ''}
    </div >
  );
};
export default CWFooter;
